import {Injectable} from '@angular/core';
import {RequesterService} from '../../services/requester.service';
import {AccountPageModel, AccountPageResponceModel} from './models/account-page.model';
import {EventsService} from '../../services/events.service';
import {AnalyticsService} from '../../services/analytics.service';

@Injectable({
    providedIn: 'root'
})
export class AccountService {

    constructor(
        private event: EventsService,
        private analytics: AnalyticsService,
        private requesterService: RequesterService) {
    }

    getAccountPageData(): Promise<AccountPageModel> {
        return this.requesterService.get('getMyProfileForm')
            .then(data => {
                return data.result;
            })
            .catch(e => {
                console.log('Error getMyProfileForm >> ', e);
            });
    }

    saveMyProfileForm(model: AccountPageModel): Promise<AccountPageResponceModel> {
        return this.requesterService.put('saveMyProfileForm', model)
            .then(data => {
                const response = new AccountPageResponceModel();
                if (!!data.result.status) {
                    response.status = data.result;
                    this.event.publish('account.saveMyProfileForm', response.status);
                } else {
                    response.form = data.result;
                }
                return response;
            })
            .catch(e => {
                console.error('Error in: saveMyProfileForm', e);
                return null;
            });
    }

}
